<div class="row">
  <div class="col-lg-8">
    <h2 *scText="heading()" class="text-section__heading"></h2>
    @if (showRichText() && richText(); as richText) {
      <wl-rich-text-wrapper [field]="richText">
        <div class="text-section__richText mb-2"></div>
      </wl-rich-text-wrapper>
    }
    <ng-content select="[call-to-action-button]" />
    <ng-content select="[app-store-buttons]" />
  </div>
</div>
